<template>
  <div :class="{
      'animated fadeIn': true,
      card,
    }" v-show="entity !== undefined">

    <div v-if="card" class="card-header">
      <slot name="header"></slot>
    </div>

    <div :class="{ 'card-box': card, row: !card }">
      <div class="col">
        <draggable v-model="collection" class="sortable-container p-3 row" element="div" @end="handleDrop">
          <component v-for="instance in collection"
            :key="instance.id"
            :is="entity.options.component"
            :instance="instance"
            :entity="entity"
            :http="http"

            @item-removed="removeFromCollection(arguments[0])">
          </component>
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
import { get, remove } from 'lodash'

export default {
  props: {
    entity: {
      type: Object,
      required: true
    },

    http: {
      type: Object,
      required: true
    },

    filter: {
      type: Object,
      default () { return {} }
    },

    card: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      processing: false,

      collection: []
    }
  },

  watch: {
    /**
     * If and entitiy changes but the compoennt should be the same we will just update the collection
     */
    entity (prev, next) {
      const nextEntity = get(next, 'key', null)
      const previousEntity = get(prev, 'key', null)

      if (nextEntity !== previousEntity) {
        this.getCollection()
      }
    }
  },

  computed: {
    options () { return this.entity.options || {} }
  },

  methods: {
    getCollection () {
      const self = this

      self.$Progress.start()
      self.processing = true

      self.http.index({ params: {
        _onepage: true,
        search: self.filter,
        '_search[]': self.$route.query.type_id ? `type_id:${self.$route.query.type_id}` : '',
        scopes: self.options.scopes || [],
        with: self.options.with || []
      }}).then((res, body) => {
        self.$Progress.finish()
        self.processing = false
        self.collection = res.data.collection
      })
    },

    removeFromCollection (removedInstance) {
      const self = this
      // Let's perform an optmistic update
      remove(self.collection, (o) => o.id === removedInstance.id)
      self.$nextTick(() => { self.getCollection() })
    },

    handleDrop ({ newIndex, oldIndex }) {
      const self = this

      if (!self.processing && newIndex !== oldIndex) {
        self.processing = true
        let previousId = null

        if (newIndex !== 0) {
          previousId = get(self.collection[newIndex - 1], 'id', null)
        }

        let elementId = get(self.collection[newIndex], 'id')

        self.http.resource.put(`${elementId}/after/${previousId || ''}`)
          .finally(() => {
            self.processing = false
          })
      }
    }
  },

  created () {
    this.getCollection()
  }
}
</script>

<style lang="sass">
  .sortable-container
    border: 1px solid #d7d7d7
    background-color: #f7f7f7

    cursor: move
</style>



// WEBPACK FOOTER //
// src/components/ui/Sortable.vue